import Kostenart from './kostenart';

const kostenartConverter = {
    toFirestore: (kostenart) => {
        return kostenart.getFirestore();
    },
    fromFirestore: (snapshot) => {
        const data = snapshot.data();
        return new Kostenart(
            snapshot.id,
            data.name,
            data.icon,
            data.belege,
            data.datum,
            data.ausgabenbegrenzung,
            data.lerneinheiten,
            data.hinweis
        );
    }
};

export default kostenartConverter;